<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>تقرير بحالات ايصالات الفرع</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                          هنا يتم متابعه ايصالات الفروع
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <label>الفرع</label>
                                <select class="form-control"  v-model="branche">
                                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6' style="padding :25px">
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> عرض </b>
                                </button>
                              </div>
                              <div style="padding-top:30px">
                              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                  <thead>
                                    <tr>
                                      <th style='padding:2px;text-align: center'>م</th>
                                      <th style='padding:2px;text-align: center'>الحافظة</th>
                                      <th style='padding:2px;text-align: center'>العدد</th>
                                      <th style='padding:2px;text-align: center'>مصدر</th>
                                      <th style='padding:2px;text-align: center'>مرتجع</th>
                                      <th style='padding:2px;text-align: center'>موزع</th>
                                      <th style='padding:2px;text-align: center'>ملغى</th>
                                      <th style='padding:2px;text-align: center'>مسوى</th>
                                      <th style='padding:2px;text-align: center'>مفقود</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>

                                         <td align='center'>{{index +1 }}</td>
                                         <td align='center'>{{record.folder_date}}</td>
                                         <td align='center'>{{record.type}}</td>
                                         <td align='center'>{{record.type0}}</td>
                                         <td align='center'>{{record.type1}}</td>
                                         <td align='center'>{{record.type2}}</td>
                                         <td align='center'>{{record.type3}}</td>
                                         <td align='center'>{{record.type4}}</td>
                                         <td align='center'>{{record.type5}}</td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<style>
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'BranchReceiptsStatus',
  components: {
    tbDate
  },
  data () {
    return {
      today: true,
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: '',
      validationErrors: '',
      records: {},
      isLoadingData: false,
      disabled: true,
      branches: [],
      branche: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-branch-receipts-status', {
        token: localStorage.getItem('token'),
        branch: this.branche,
        folder_date_from: this.from_date,
        folder_date_to: this.to_date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/GetBranchReceiptsStatus.vue